module.exports = __webpack_public_path__ + "images/5c4492718cdf3718efd0f71e632ed8ba-megaFam.png";